import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

import { SimpleSliderMessage } from "./SimpleSliderMessage";
import { SimpleSliderStyled } from "./SimpleSliderStyles";

interface SlidesGroup {
  id: number;
  subtitle: string;
  title: React.ReactNode;
}
interface SimpleSliderProps {
  slidesContent: SlidesGroup[];
  slidesToShow?: number;
  dots?: boolean;
  arrows?: boolean;
  autoplay?: boolean;
  autoplaySpeed?: number;
}

export const SimpleSlider: React.FunctionComponent<SimpleSliderProps> = ({
  slidesContent,
  ...props
}) => {
  const slides = slidesContent.map(({ id, ...slideProps }) => {
    return (
      <div key={id} className="simple-slider__slide">
        <SimpleSliderMessage {...slideProps} />
      </div>
    );
  });

  return (
    <SimpleSliderStyled className="simple-slider">
      <Slider {...props}>{slides}</Slider>
    </SimpleSliderStyled>
  );
};
